// @ts-nocheck
import axios from 'axios';
import { BASE_URL } from '../../../../queries/useDataEngine';

export const WorkflowService = {
  createWorkflow: (payload, loader = true) =>
    axios.post(BASE_URL + '/workflow/create', payload, { loader }),
  cloneWorkflow: (payload, loader = true) =>
    axios.post(BASE_URL + '/workflow/clone', payload, { loader }),
  generateTextToWorkflow: (payload, loader = true) =>
    axios.post(BASE_URL + '/llm/text-to-workflow', payload, { loader }),
  getWorkflowList: (params) =>
    axios.get(BASE_URL + '/workflow/viewAll', { params, loader: false }),
  compileWorkflow: (payload, loader = true) =>
    axios.post(BASE_URL + '/workflow/recompile', payload, { loader }),
  updateWorkflow: (payload, loader = true) =>
    axios.put(BASE_URL + '/workflow/update', payload, { loader }),
  checkWorkflowStateDeletable: (payload, loader = true) =>
    axios.post(BASE_URL + '/workflow/checkstate', payload, { loader }),
  getSingleWorkflow: (params, loader = true) =>
    axios.get(BASE_URL + '/workflow/view', { params, loader }),
  getDraftWorkflow: (params, loader = false) =>
    axios.get(BASE_URL + '/workflow/saveAsDraft', {
      params,
      loader,
      suppressErrorToast: true,
    }),
  saveDraftWorkflow: (payload, loader = false) =>
    axios.post(BASE_URL + '/workflow/saveAsDraft', payload, {
      loader,
      suppressErrorToast: true,
    }),
  deleteDraftWorkflow: (params, loader = false) =>
    axios.delete(BASE_URL + '/workflow/saveAsDraft', {
      params,
      loader,
    }),
  updateDraftWorkflow: (payload, loader = false) =>
    axios.put(BASE_URL + '/workflow/saveAsDraft', payload, {
      loader,
      suppressErrorToast: true,
    }),
  fetchAllStates: (params, loader = true) =>
    axios.get(BASE_URL + '/workflow/Allstate', {
      params,
      loader,
    }),
  getNextPossibleState: (params, loader = false) =>
    axios.get(BASE_URL + '/workflow/getNextState', {
      params,
      loader,
    }),
  getPrecheckTransition: (params, loader = true) =>
    axios.get(BASE_URL + '/model-entity/precheck-transition', {
      params,
      loader,
    }),
  deleteWorkflow: (params, loader = true) =>
    axios.delete(BASE_URL + '/workflow/delete', { params, loader }),
  updateWorkflowState: (payload, loader = true) =>
    axios.post(BASE_URL + '/workflow/updateState', payload, { loader }),
  getWorkflowGroups: (params, loader = true) =>
    axios.get(BASE_URL + '/workflow/get-all-workflow-groups', {
      params,
      loader,
    }),
};
